<template>
  <div class="container-fluid">
    <div class="h3">Przypomnij hasło</div>
    <form class="form" @submit.prevent="rememberRequest">
      <div class="form__fields">
        <div class="form__group form__group--inline">
          <label class="form__label form__label--inline">Adres e-mail</label>
          <div
              class="form__group"
              :class="{ 'form__group--error': $v.email.$error }"
          >
            <input
                class="form__input"
                v-model.trim="$v.email.$model"
                placeholder="Wpisz adres e-mail"
                type="text"
            />
            <div class="form__errors" v-if="$v.email.$error">
              <div class="form__error" v-if="!$v.email.required">
                Pole jest wymagane
              </div>
              <div class="form__error" v-if="!$v.email.email">
                Nieprawidłowy adres e-mail
              </div>
            </div>
          </div>
        </div>

        <ButtonPrimary class="form__button" :disabled="rememberProcess"
        >Zrestartuj hasło</ButtonPrimary
        >
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/components/form/form";
</style>
<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
import { required, email } from "vuelidate/lib/validators";
import {requestPassword} from "@/services/user";
import { validateMessages } from "@/config";
export default {
  name: "RememberPasswordForm",
  components: {
    ButtonPrimary: () => import("@/pages/components/buttons/ButtonPrimary"),
  },
  data() {
    return {
      email: "",
      validateMessage: "",
      rememberProcess: false,
    };
  },
  methods: {
    rememberRequest() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.requestProcess = true;
        const data = {
          email: this.email
        };

        requestPassword(data)
            .then(() => {
              this.$notify({
                group: validateMessages.group,
                type: "success",
                text: "Wysłaliśmy do Ciebie e-mail z dalszymi instrukcjami.",
              });
              this.$router.push({
                name: "Login",
                params: { lang: "pl" },
              });

            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 401) {
                  this.validateMessage = "Nieprawidłowe dane logowania.";
                }
              } else {
                this.validateMessage = "Wystąpił problem. Zgłoś błąd do administracji";
              }
            })
            .finally(() => {
              this.requestProcess = false;
            });
      }
    }
  },
  validations: {
    email: {
      required,
      email,
    },
  },
};
</script>

